<template>
  <v-dialog
    :model-value="open"
    @update:model-value="handleOpenChange"
    fullscreen
    :scrim="false"
    @keydown.stop.esc="handleClose"
  >
    <v-card flat>
      <v-toolbar
        flat
        dense
        color="white"
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn class="media-download-btn" download icon @click="handleDownload">
            <v-icon>mdi-cloud-download</v-icon>
          </v-btn>

          <v-btn class="media-close-btn" icon @click="handleClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="media-container pa-0">
        <requirement-attachment-media-image
          v-if="mediaType === 'image'"
          :title="title"
          :src="url"
        ></requirement-attachment-media-image>

        <requirement-attachment-media-unknown
          v-else
          :url="url"
          :title="title"
        ></requirement-attachment-media-unknown>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Storage from '@/storage'
import RequirementAttachmentMediaImage from '@/components/RequirementAttachmentMediaImage'
import RequirementAttachmentMediaUnknown from '@/components/RequirementAttachmentMediaUnknown'

export default {
  components: {
    RequirementAttachmentMediaImage,
    RequirementAttachmentMediaUnknown
  },
  props: {
    open: Boolean,
    title: String,
    url: String,
    mediaType: String
  },
  data () {
    return {
      storage: null
    }
  },
  methods: {
    handleOpenChange (open) {
      this.$emit('open-change', open)
    },
    handleClose () {
      this.$emit('open-change', false)
    },
    handleDownload () {
      const key = decodeURIComponent(this.url.split('?X-Amz')[0].split('/').slice(3).join('/'))
      this.storage
        .getFile(key)
        .then((signedURL) => {
          const link = document.createElement('a')
          link.href = signedURL
          link.download = this.title
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    }
  },
  mounted () {
    this.storage = new Storage()
  }
}
</script>

<style scoped>
  .media-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 48px);
  }
</style>
